/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PaperLockIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABE0lEQVR4nN2VMW4CQQxFFwkFRTQ5TwTaCrFFxt8UEztSpJwA0cINlqvQJicI4igkTc4QomGh2V0GrVkKYsnVePzG/uOZJPk35r2/I5alg3wR687ijmVLrHnIVQGEBWtiqnpeAVxycio79Luugl2bnsQAgDzW6fTEL4NWACFRHQCQYSuAq7eIbh6AEyLHrHwBTCLHrHwBKgHWVjjWjZto5r2/H41e+8DzmFjm7QCgqzRNu9HSrADHsgXeHoq9MgtPTeE6PQtoIjKOvYe+O8gHsf7WamgV2bEuwp4sy3rBD7os7C3C/qXsHJJvTsfJunSS/WfRaIioybA1+XASC6D4MjU/V4mD/JgAFrs+ALKOTPhnCPoDkMaSj58tN2oAAAAASUVORK5CYII=)
 */
export const PaperLockIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M5 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h7.5a.5.5 0 0 0 .5-.5V19c0-.1 0-.2.02-.31.03-.35-.21-.69-.56-.69H6a1 1 0 1 1 0-2h8.4c.21 0 .4-.13.49-.33a4.5 4.5 0 0 1 6.2-2.16c.38.2.91-.05.91-.48V5a3 3 0 0 0-3-3H5Zm1 4a1 1 0 0 0 0 2h5a1 1 0 1 0 0-2H6Zm-1 6a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Z"
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        d="M16 18h.5v-.5a2.5 2.5 0 0 1 5 0v.5h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1Zm4-.5v.5h-2v-.5a1 1 0 0 1 2 0Z"
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
